import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const { t } = useTranslation();

  const partners = [
    { name: 'Yamaha', url: 'https://www.yamaha-motor.eu/pt/pt/home/', logo: 'https://nautitours.pt/multimedia/Yamaha.jpg' },
    { name: '818', url: 'http://www.818.pt/', logo: 'https://nautitours.pt/multimedia/818_logo.jpg' },
    { name: 'Clean the Sea', url: 'https://www.yamaha-motor.eu/pt/pt/experience/clean-the-sea/', logo: 'https://nautitours.pt/multimedia/clean.jpg' },
    { name: 'Natural.pt', url: 'http://www.natural.pt/', logo: 'https://nautitours.pt/multimedia/Natural.jpg' },
    { name: 'Turismo de Portugal', url: 'https://www.turismodeportugal.pt/pt/Paginas/homepage.aspx', logo: 'https://nautitours.pt/multimedia/Turismo-de-portugal.jpg' }
  ];

  const socialLinks = [
    { icon: <FaFacebook />, url: 'https://www.facebook.com/NautitoursVRSA/', label: 'Facebook' },
    { icon: <FaInstagram />, url: 'https://www.instagram.com/nautitoursvrsa/', label: 'Instagram' },
    { icon: <FaYoutube />, url: 'https://www.youtube.com/@Nautitours', label: 'YouTube' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Partners Section */}
      <div className="border-b border-gray-800 py-8">
        <div className="container mx-auto px-4">
          <h3 className="text-center text-xl font-semibold mb-6">{t('footer.partners')}</h3>
          <div className="flex flex-wrap justify-center items-center gap-8">
            {partners.map((partner) => (
              <a
                key={partner.name}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-16 w-auto object-contain"
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-blue-400">Nautitours</h3>
            <p className="text-gray-400">
              Experiências náuticas inesquecíveis no Rio Guadiana.
              Descubra a beleza da natureza e a história da região.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-blue-400">Links</h3>
            <div className="flex flex-col space-y-2">
              <Link to="/activities" className="text-gray-400 hover:text-blue-400 transition-colors">
                {t('nav.activities')}
              </Link>
              <Link to="/about" className="text-gray-400 hover:text-blue-400 transition-colors">
                {t('nav.about')}
              </Link>
              <Link to="/contact" className="text-gray-400 hover:text-blue-400 transition-colors">
                {t('nav.contact')}
              </Link>
              <Link to="/admin" className="text-gray-400 hover:text-blue-400 transition-colors">
                {t('nav.admin')}
              </Link>
            </div>
          </div>

          {/* Social & Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-blue-400">{t('footer.social')}</h3>
            <div className="flex space-x-4 mb-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-2xl hover:text-blue-400 transition-colors"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
            <a
              href="https://api.whatsapp.com/send?phone=351964423117"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-green-600 hover:bg-green-700 px-4 py-2 rounded transition-colors"
            >
              <FaWhatsapp className="text-xl" />
              <span>{t('contact.whatsapp')}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800 py-6">
        <div className="container mx-auto px-4 text-center text-gray-400">
          <p>© {new Date().getFullYear()} Nautitours. {t('footer.rights')}.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;